<div
  class="dropdown"
  [class.isOpen]="isOpen()"
  [class.is-disabled]="disabled()"
  [class.opens-up]="direction() === 'up'"
  #uiDropdownContainer
>
  <button class="dropdown-button" [disabled]="disabled()" (click)="onOpen()">
    <span class="dropdown-button-info color-{{ displayColor() }}">{{ displayText() }}</span>
    <ui-inline-svg class="dropdown-button-info icon color-{{ displayColor() }}" name="tooltip-arrow-top"></ui-inline-svg>
  </button>
  <div class="dropdown-list">
    <div class="dropdown-list-container" role="listbox" aria-activedescendant="option-1">
      <div class="dropdown-list-container-separator"></div>

      @for (item of options(); track i; let i = $index) {
      <div class="dropdown-list-container-option" role="option" [id]="'option-' + i"
        [attr.aria-selected]="item.value === value()" (click)="onSelect(item)" >
        <span class="dropdown-list-container-option-text" role="presentation">{{ item.label }}</span>
      </div>
      }
    </div>
  </div>
</div>